import { seoOgImage } from './SeoStore';

export const updateSeoOgImage = (value) => seoOgImage.update(oldValue => value);
